import { InjectionToken } from '@angular/core';

export const FILES_PANEL_DOMAIN = new InjectionToken<string>(
  'FILES_PANEL_DOMAIN'
);

export const FILES_APIV3_DOMAIN = new InjectionToken<string>(
  'FILES_APIV3_DOMAIN'
);
